import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgRt = (props) => /* @__PURE__ */ _jsx("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	viewBox: "0 0 85 80",
	...props,
	children: /* @__PURE__ */ _jsxs("g", {
		transform: "translate(2 22)",
		fill: "none",
		fillRule: "evenodd",
		children: [
			/* @__PURE__ */ _jsx("path", {
				d: "M31-1c.552 0 1.052.224 1.414.586C32.776-.052 33 .448 33 1h0v23H-1V1c0-.552.224-1.052.586-1.414A1.994 1.994 0 011-1h0z",
				stroke: "#0D0E10",
				strokeWidth: 2,
				strokeLinejoin: "round"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M33 24v8h-2.07a6.98 6.98 0 01-1.98 3.95A6.978 6.978 0 0124 38a6.977 6.977 0 01-4.856-1.958 6.985 6.985 0 01-2.048-3.882h0l-1.178-.088a6.982 6.982 0 01-1.968 3.878A6.978 6.978 0 019 38a6.977 6.977 0 01-4.856-1.958 6.985 6.985 0 01-2.053-3.913h0l-1.156-.13a1.993 1.993 0 01-1.35-.585A1.994 1.994 0 01-1 30h0v-6h34z",
				stroke: "#0D0E10",
				strokeWidth: 2
			}),
			/* @__PURE__ */ _jsx("circle", {
				fill: "#0D0E10",
				cx: 9,
				cy: 32,
				r: 2
			}),
			/* @__PURE__ */ _jsx("circle", {
				fill: "#0D0E10",
				cx: 24,
				cy: 32,
				r: 2
			}),
			/* @__PURE__ */ _jsx("path", {
				fill: "#0D0E10",
				d: "M34 31h6v2h-6z"
			}),
			/* @__PURE__ */ _jsxs("g", {
				transform: "translate(67 6)",
				children: [
					/* @__PURE__ */ _jsx("path", {
						d: "M7.53-1a2.996 2.996 0 012.863 2.105h0l4.47 14.305a3 3 0 01.137.895h0V24c0 .552-.224 1.052-.586 1.414A1.994 1.994 0 0113 26c-.29 1.533-1.006 2.905-2.05 3.95A6.978 6.978 0 016 32a6.977 6.977 0 01-4.856-1.958 6.98 6.98 0 01-2.14-4.8h0L-1 1c0-.552.224-1.052.586-1.414A1.994 1.994 0 011-1h6.53z",
						stroke: "#0D0E10",
						strokeWidth: 2
					}),
					/* @__PURE__ */ _jsx("path", {
						fill: "#0D0E10",
						d: "M3 0h2v13H3zM0 13h14v2H0z"
					}),
					/* @__PURE__ */ _jsx("circle", {
						fill: "#0D0E10",
						cx: 6,
						cy: 26,
						r: 2
					})
				]
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M64-1c.552 0 1.052.224 1.414.586C65.776-.052 66 .448 66 1h0v23H38V1c0-.552.224-1.052.586-1.414A1.994 1.994 0 0140-1h0z",
				stroke: "#0D0E10",
				strokeWidth: 2,
				strokeLinejoin: "round"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M66 24v8H54.93a6.98 6.98 0 01-1.98 3.95A6.978 6.978 0 0148 38a6.977 6.977 0 01-4.856-1.958 6.985 6.985 0 01-2.048-3.882h0L38 31.928V24h28z",
				stroke: "#0D0E10",
				strokeWidth: 2
			}),
			/* @__PURE__ */ _jsx("circle", {
				fill: "#0D0E10",
				cx: 48,
				cy: 32,
				r: 2
			})
		]
	})
});
export default SvgRt;
